import { Table } from "@similarweb/pro-logic-components";

import { WidgetContainer } from "app/components/React/WidgetContainer/WidgetContainer";
import { useCategoriesComparison } from "app/pages/industry-analysis/categories-context/CategoriesContext";
import { useTranslation } from "pro-features/components/WithTranslation";

import { useAudienceComparisonData } from "../hooks/useAudienceComparisonData";
import type { AudienceTableRow } from "../types";
import { getFromTo } from "../utils";

import { columnConfig } from "./columnConfig";

const getSubtitleFilters = () => {
    const fromTo = getFromTo();
    return [
        {
            filter: "date",
            value: {
                to: fromTo.to,
                format: "MMMM YYYY",
            },
        },
    ];
};

export const AudienceComparisonWidget = () => {
    const t = useTranslation();
    const subtitleFilters = getSubtitleFilters();
    const { categories } = useCategoriesComparison();
    const { data, isError, isLoading } = useAudienceComparisonData(categories);

    return (
        <WidgetContainer
            withBorder
            minHeight={200}
            noData={isError}
            subtitleFilters={subtitleFilters}
            title={t("analysis.audience.title")}
            automationId="industry-analysis-overview-comparison-audience"
        >
            <Table<AudienceTableRow>
                sticky={false}
                withArrowButtons={false}
                scroll={{ x: null, y: null }}
                isLoading={isLoading}
                loaderRowCount={3}
                columnConfig={columnConfig}
                data={data}
                theme="white"
                bordersConfig={{
                    header: false,
                }}
            />
        </WidgetContainer>
    );
};
